export const queryKeys = {
  MATERIAL_MARKET_INFO: "MATERIAL_MARKET_INFO",
  GLOBAL_MARKET_INFO: "GLOBAL_MARKET_INFO",

  AVAILABLE_COUNTRIES: "AVAILABLE_COUNTRIES",
  COUNTRIES_BY_MATERIAL: "COUNTRIES_BY_MATERIAL",
  COUNTRIES: "COUNTRIES",

  MATERIAL_CATEGORY_BY_NAME: "MATERIAL_CATEGORY_BY_NAME",
  PRODUCT_SERVICE_FAMILY: "PRODUCT_SERVICE_FAMILY",
  PRODUCT_SERVICE_CLASS: "PRODUCT_SERVICE_CLASS",
  SERVICES: "SERVICES",
  GOODS: "GOODS",

  CHATS: "CHATS",
  CHAT: "CHAT",
  MULTIPLE_ORDER_CHAT: "MULTIPLE_ORDER_CHAT",

  HISTORIC: "HISTORIC",

  BUYER_KPIS: "BUYER_KPIS",
  BUYER_KPIS_CURRENT_MONTH: "BUYER_KPIS_CURRENT_MONTH",
  BUYER_KPIS_CURRENT_YEAR: "BUYER_KPIS_CURRENT_YEAR",
  BUYER_KPIS_MONTH: "BUYER_KPIS_MONTH",
  BUYER_KPIS_YEAR: "BUYER_KPIS_YEAR",
  BUYER_KPIS_CUSTOM: "BUYER_KPIS_CUSTOM",
  SELLER_KPIS: "SELLER_KPIS",
  ANALYST_KPIS: "ANALYST_KPIS",
  ANALYST_KPIS_CURRENT_MONTH: "ANALYST_KPIS_CURRENT_MONTH",
  ANALYST_KPIS_CURRENT_YEAR: "ANALYST_KPIS_CURRENT_YEAR",
  ANALYST_KPIS_CUSTOM: "ANALYST_KPIS_CUSTOM",
  MANAGER_DASHBOARD: "MANAGER_DASHBOARD",
  ANALYTICS_DASHBOARD: "ANALYTICS_DASHBOARD",
  ANALYTICS_SUPPLIER_OPTIONS: "ANALYTICS_SUPPLIER_OPTIONS",
  POSITION: "POSITION",
  FILE_URL: "FILE_URL",

  MATERIAL_COMPANIES_OPPORTUNITIES_BY_COUNTRY:
    "MATERIAL_COMPANIES_OPPORTUNITIES_BY_COUNTRY",
  MATERIAL_INVITATIONS_OPPORTUNITIES: "MATERIAL_INVITATIONS_OPPORTUNITIES",
  INVITATIONS_BY_EMAIL: "INVITATIONS_BY_EMAIL",
  INVITED_MATERIAL_SUPPLIERS: "INVITED_MATERIAL_SUPPLIERS",
  INVITED_ORDER_SUPPLIERS: "INVITED_ORDER_SUPPLIERS",

  ALL_COMPANY_MATERIALS: "ALL_COMPANY_MATERIALS",
  USER_MATERIAL_CATEGORIES: "USER_MATERIAL_CATEGORIES",
  MATERIAL: "MATERIAL",
  MATERIALS: "MATERIALS",
  FOUND_MATERIALS: "FOUND_MATERIALS",
  MATERIALS_BY_OWNER: "MATERIALS_BY_OWNER",
  USER_MATERIALS_BY_COMPANY: "USER_MATERIALS_BY_COMPANY",
  ALL_MATERIALS: "ALL_MATERIALS",

  ALL_MATERIALS_OFFERS: "ALL_MATERIALS_OFFERS",
  ALL_COMPANY_MATERIAL_OFFERS: "ALL_COMPANY_MATERIAL_OFFERS",
  MATERIAL_OFFER: "MATERIAL_OFFER",
  MATERIAL_OFFERS: "MATERIAL_OFFERS",
  CHECK_MATERIAL_OFFER: "CHECK_MATERIAL_OFFER",

  OPPORTUNITIES: "OPPORTUNITIES",
  MULTIPLE_OPPORTUNITIES: "MULTIPLE_OPPORTUNITIES",

  ORDER: "ORDER",
  ORDERS: "ORDERS",
  SECOND_ROUND_ELIGIBLE_SUPPLIERS: "SECOND_ROUND_ELIGIBLE_SUPPLIERS",
  JOINT_ORDER: "JOINT_ORDER",
  JOINT_ORDERS: "JOINT_ORDERS",
  ALL_ORDERS: "ALL_ORDERS",
  SUPPLIER_RFQS: "SUPPLIER_RFQS",
  SUPPLIER_BIDDINGS: "SUPPLIER_BIDDINGS",
  TENDER: "TENDER",
  ORDERS_COUNT: "ORDERS_COUNT",
  POTENTIAL_SUPPLIERS: "POTENTIAL_SUPPLIERS",
  AWARDED_ORDERS: "AWARDED_ORDERS",
  AWARDED_SUPPLIERS_BY_ORDER_ID: "AWARDED_SUPPLIERS_BY_ORDER_ID",

  MULTIPLE_OFFERS_ON_ORDERS: "MULTIPLE_OFFERS_ON_ORDERS",
  OFFERS_ON_ORDERS: "OFFERS_ON_ORDERS",
  OFFER: "OFFER",
  MY_OFFER_ON_ORDER: "MY_OFFER_ON_ORDER",
  OFFERS: "OFFERS",
  MULTIPLE_OFFER: "MULTIPLE_OFFER",
  MULTIPLE_OFFERS: "MULTIPLE_OFFERS",
  OFFERS_AWARDED_FOR_DELIVERIES: "OFFERS_AWARDED_FOR_DELIVERIES",
  JOINT_ORDER_OFFER_STATUS: "JOINT_ORDER_OFFER_STATUS",

  SITE: "SITE",
  SITES: "SITES",
  SITES_PAGINATED: "SITES_PAGINATED",

  USER: "USER",
  USERS_BY_COMPANY: "USERS_BY_COMPANY",
  USERS_BY_COMPANY_PAGINATED: "USERS_BY_COMPANY_PAGINATED",
  USER_GROUPS: "USER_GROUPS",
  USER_GROUP: "USER_GROUP",
  ROLES: "ROLES",
  ROLE_ABILITIES: "ROLE_ABILITIES",

  BUYER: "BUYER",
  FOUND_BUYERS: "FOUND_BUYERS",
  SELLER: "SELLER",

  DELIVERIES: "DELIVERIES",
  DELIVERY: "DELIVERY",
  DELIVERIES_COUNT: "DELIVERIES_COUNT",

  READ_FILE: "READ_FILE",

  NOTIFICATIONS: "NOTIFICATIONS",
  UNREAD_NOTIFICATIONS: "UNREAD_NOTIFICATIONS",

  SUPPLIERS: "SUPPLIERS",
  SUPPLIER: "SUPPLIER",
  SUPPLIERS_BY_BUYER: "SUPPLIERS_BY_BUYER",
  SUPPLIER_INVITATION_RESEND_PREVIEW: "SUPPLIER_INVITATION_RESEND_PREVIEW",
  BUYER_SELLER_WITHOUT_OFFER: "BUYER_SELLER_WITHOUT_OFFER",

  COMPANY_PROFILE: "COMPANY_PROFILE",

  // AI Profile and Opportunity Discovery
  OPPORTUNITY_COUNTS: "OPPORTUNITY_COUNTS",
  OPPORTUNITY_TOTAL_COUNT: "OPPORTUNITY_TOTAL_COUNT",
  OPPORTUNITY_FILTERS: "OPPORTUNITY_FILTERS",
  OPPORTUNITY_FILTERS_ALL: "OPPORTUNITY_FILTERS_ALL",
  OPPORTUNITY_LIST: "OPPORTUNITY_LIST",

  SUPPLIER_AI_ANALYSIS: "SUPPLIER_AI_ANALYSIS",
  SUPPLIER_ASSIGNED_CATEGORIES: "SUPPLIER_ASSIGNED_CATEGORIES",

  // Purchase Requests V2
  PURCHASE_REQUEST_IMPORT_SESSION: "PURCHASE_REQUEST_IMPORT_SESSION",
  PURCHASE_REQUEST_IMPORT_FORMATS: "PURCHASE_REQUEST_IMPORT_FORMATS",
  PURCHASE_REQUEST_IMPORT_OPTIONS: "PURCHASE_REQUEST_IMPORT_OPTIONS",
  PURCHASE_REQUEST_IMPORT_JOB: "PURCHASE_REQUEST_IMPORT_JOB",

  PURCHASE_REQUESTS_V2_ME: "PURCHASE_REQUESTS_V2_ME",
  PURCHASE_REQUESTS_V2_COMPANY: "PURCHASE_REQUESTS_V2_COMPANY",
  PURCHASE_REQUEST_V2: "PURCHASE_REQUEST_V2",
  PURCHASE_REQUEST_V2_ITEMS: "PURCHASE_REQUEST_V2_ITEMS",
  PURCHASE_REQUEST_V2_SERVICES_TO_QUOTE: "PURCHASE_REQUEST_V2_SERVICES_TO_QUOTE",
  PURCHASE_REQUEST_V2_BUYER_ITEMS: "PURCHASE_REQUEST_V2_BUYER_ITEMS",
  PURCHASE_REQUEST_V2_COMPANY_ITEMS: "PURCHASE_REQUEST_V2_COMPANY_ITEMS",
  PURCHASE_REQUESTS_V2_ME_REQUESTER: "PURCHASE_REQUESTS_V2_ME_REQUESTER",
  PURCHASE_REQUESTS_V2_BY_CATEGORIES: "PURCHASE_REQUESTS_V2_BY_CATEGORIES",
  PURCHASE_REQUEST_V2_ITEMS_BY_CATEGORIES:
    "PURCHASE_REQUEST_V2_ITEMS_BY_CATEGORIES",
  PURCHASE_REQUEST_V2_AVAILABLE_CATEGORIES:
    "PURCHASE_REQUEST_V2_AVAILABLE_CATEGORIES",
  PURCHASE_REQUESTS_V2_BY_TAGS: "PURCHASE_REQUESTS_V2_BY_TAGS",
  PURCHASE_REQUEST_V2_ITEMS_BY_TAGS: "PURCHASE_REQUEST_V2_ITEMS_BY_TAGS",
  PURCHASE_REQUEST_V2_AVAILABLE_TAGS: "PURCHASE_REQUEST_V2_AVAILABLE_TAGS",
  PURCHASE_REQUEST_V2_AVAILABLE_TAGS_FOR_REQUEST:
    "PURCHASE_REQUEST_V2_AVAILABLE_TAGS_FOR_REQUEST",
  PURCHASE_REQUEST_V2_ITEMS_BY_TAGS_FOR_REQUEST:
    "PURCHASE_REQUEST_V2_ITEMS_BY_TAGS_FOR_REQUEST",
  PURCHASE_REQUEST_V2_ITEMS_FILTER: "PURCHASE_REQUEST_V2_ITEMS_FILTER",
  PURCHASE_REQUEST_V2_AVAILABLE_ASSIGNED_BUYERS:
    "PURCHASE_REQUEST_V2_AVAILABLE_ASSIGNED_BUYERS",
  PURCHASE_REQUEST_V2_ASSIGNABLE_BUYERS: "PURCHASE_REQUEST_V2_ASSIGNABLE_BUYERS",
  PURCHASE_REQUEST_V2_AVAILABLE_CATEGORIES_FOR_REQUEST:
    "PURCHASE_REQUEST_V2_AVAILABLE_CATEGORIES_FOR_REQUEST",
  PURCHASE_REQUEST_V2_ITEMS_SEARCH: "PURCHASE_REQUEST_V2_ITEMS_SEARCH",
  PURCHASE_ORDERS: "PURCHASE_ORDERS",
  PURCHASE_ORDER_COUNTS: "PURCHASE_ORDER_COUNTS",
  PURCHASE_ORDER: "PURCHASE_ORDER",
  SUPPLIER_PURCHASE_ORDERS: "SUPPLIER_PURCHASE_ORDERS",
  OC_TOKEN_DETAILS: "OC_TOKEN_DETAILS",
  COMPANY_REVIEW_TOKEN_DETAILS: "COMPANY_REVIEW_TOKEN_DETAILS",
  PURCHASE_ORDER_APPROVAL_RULES: "PURCHASE_ORDER_APPROVAL_RULES",
  PURCHASE_ORDER_SETTINGS: "PURCHASE_ORDER_SETTINGS",
  PURCHASE_ORDER_CATEGORY_VAT: "PURCHASE_ORDER_CATEGORY_VAT",
  PURCHASE_ORDER_HOLIDAYS: "PURCHASE_ORDER_HOLIDAYS",
  AWARDABLE_NEGOTIATIONS: "AWARDABLE_NEGOTIATIONS",
  ORDER_ACTIVITY_LOG: "ORDER_ACTIVITY_LOG",
  ORDER_SUPPLIER_ACTIVITY: "ORDER_SUPPLIER_ACTIVITY",
  ORDER_INVITATION: "ORDER_INVITATION",
  OFFER_ASSISTANT_CONVERSATION: "OFFER_ASSISTANT_CONVERSATION",
  OFFER_ASSISTANT_MESSAGE: "OFFER_ASSISTANT_MESSAGE",
  SCREEN_ASSISTANT_CONVERSATION: "SCREEN_ASSISTANT_CONVERSATION",
  SCREEN_ASSISTANT_MESSAGE: "SCREEN_ASSISTANT_MESSAGE",
  SCREEN_ASSISTANT_TITLE: "SCREEN_ASSISTANT_TITLE",
};
